module.exports = __webpack_public_path__ + "static/media/scroll-down-rally.5e057f39.svg";